import {useParams} from 'react-router-dom'
import {
  useGetLuckyDrawDetailDrawing,
  useGetLuckyDrawDetailDrawingPrizeList,
  useLuckyDrawDrawingSubmit,
} from '../../../providers/LuckyDraw.provider'
import {useForm} from 'react-hook-form'
import {DrawingModel} from '../../../models/LuckyDraw.model'

const defaultForm: DrawingModel = {
  id: '',
  prize: {},
  member: {},
  prize_type: ''
}

export function useTabDraw() {
  const {id} = useParams<{id: string}>()
  const drawingDetail = useGetLuckyDrawDetailDrawing(id)
  const form = useForm({defaultValues: defaultForm, reValidateMode: 'onChange'})
  const submit = useLuckyDrawDrawingSubmit(id)
  const dataDetail = drawingDetail.data
  const prizeListApi = useGetLuckyDrawDetailDrawingPrizeList(id ?? '', dataDetail?.id as string)
  const prizeList = prizeListApi.data?.content ?? []
  return {
    drawingDetail,
    form,
    prizeListApi,
    prizeList,
    submit,
  }
}
